import './Logo.scss'
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { CompanyTypes } from '../../types/enums';
import SageSyncLogo from '../../assets/images/sage-logo.svg';

export default function Logo() {

	const { user } = useAuth();

	return (
		<div className='logo'>
			{
				user?.companyTypeId !== CompanyTypes.EEPRO ?
					<Link to='/'>
						<img src={SageSyncLogo} alt="Sage Sync" ></img>
					</Link>
					:
					<img src={SageSyncLogo} alt="Sage Sync" ></img>

			}
		</div>
	)
}